import React from 'react';

/**
 * region for helpers*/
import validation from '../../helpers/validation';

/**
 * region for components*/
import { BaseInput } from './BaseInput';

export class InputText extends BaseInput {
    static displayName = InputText.name;

    handleOnBlur(event) {
        const self = this;

        const value = event.target.value;

        var currentTarget = event.currentTarget;
        setTimeout(function () {
            if (!currentTarget.contains(document.activeElement)) {
                if (validation.hasSpecificValidation(self.state.validators, 'url') &&
                    value.indexOf('https://') < 0 &&
                    value.indexOf('http://') < 0 &&
                    value.length > 0) {
                    self.setValueState('http://' + value)
                }
                if (self.props.handleOnBlur) {
                    self.props.handleOnBlur(event);
                }
            }
        }, 0);
    }

    handleClear(event) {
        const self = this;
        this.setValueState('', function () {
            if (self.props.showClearButton && self.props.handleOnBlur) {
                self.props.handleOnBlur(event);
            }
        });
    }

    render() {

        if (this.state.isValid) {

            const divClass = (this.props.wrapperClassName || '');

            return (
                <div className={divClass} onBlur={this.handleOnBlur.bind(this)}>
                    <input type={this.props.type || 'text'}
                        className={this.props.className}
                        maxLength={this.props.maxLength}
                        value={this.state.value}
                        id={this.props.domId}
                        name={this.props.fieldName}
                        onChange={this.handleChange}
                        disabled={this.props.disabled}
                        placeholder={this.props.placeholder}
                        autoFocus={this.props.autoFocus} />
                    {
                        this.props.showClearButton &&
                        <button type="button" className="btn btn-sm" onClick={this.handleClear.bind(this)}>
                            <i className="fas fa-times" />
                        </button>
                    }
                </div>
            );
        }
        else {
            const inputClass = this.props.className + ' form-control is-invalid js-invalid-control';
            let divClass = (this.props.wrapperClassName || '') + 'is-invalid';

            if (this.props.validationAsTooltip) {
                divClass += ' has-danger-tooltip';
            }

            return (
                <div className={divClass} onBlur={this.handleOnBlur.bind(this)}>
                    <input type={this.props.type || 'text'}
                        maxLength={this.props.maxLength}
                        className={inputClass}
                        value={this.state.value}
                        name={this.props.fieldName}
                        id={this.props.domId}
                        disabled={this.props.disabled}
                        onChange={this.handleChange}
                        placeholder={this.props.placeholder}
                        autoFocus={this.props.autoFocus} />
                    <div className="invalid-feedback">{this.state.validation_text}</div>
                </div>
            );
        }
    }


}
